import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$3f5a } from '/home/bas/app_ae9ac18e-00ad-45b7-a95c-4db11aa35339/schemes/teampulseAuth.js'
import { Oauth2Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/login",
    "home": "/clubs",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "api"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // api
  $auth.registerStrategy('api', new Scheme$3f5a($auth, {
  "endpoints": {
    "login": {
      "url": "/accounts/signin",
      "method": "post"
    },
    "logout": {
      "url": "/accounts/signout",
      "method": "post"
    },
    "refresh": {
      "url": "/accounts/refresh-access-token",
      "method": "post"
    },
    "user": {
      "url": "/players/{id}/user-profile",
      "method": "get"
    }
  },
  "refreshToken": {
    "property": "refresh_token"
  },
  "token": {
    "type": "Bearer",
    "property": "access_token"
  },
  "user": {
    "autoFetch": true,
    "property": false
  },
  "appVersion": "6.0.0",
  "name": "api"
}))

  // apiWithApple
  $auth.registerStrategy('apiWithApple', new Scheme$3f5a($auth, {
  "endpoints": {
    "login": {
      "url": "/accounts/auth/apple",
      "method": "post"
    },
    "logout": {
      "url": "/accounts/signout",
      "method": "post"
    },
    "refresh": {
      "url": "/accounts/refresh-access-token",
      "method": "post"
    },
    "user": {
      "url": "/players/{id}/user-profile",
      "method": "get"
    }
  },
  "refreshToken": {
    "property": "refresh_token"
  },
  "token": {
    "type": "Bearer",
    "property": "access_token"
  },
  "user": {
    "autoFetch": true,
    "property": false
  },
  "appVersion": "6.0.0",
  "name": "apiWithApple"
}))

  // apiWithFb
  $auth.registerStrategy('apiWithFb', new Scheme$3f5a($auth, {
  "endpoints": {
    "login": {
      "url": "/accounts/auth/facebook",
      "method": "post"
    },
    "logout": {
      "url": "/accounts/signout",
      "method": "post"
    },
    "refresh": {
      "url": "/accounts/refresh-access-token",
      "method": "post"
    },
    "user": {
      "url": "/players/{id}/user-profile",
      "method": "get"
    }
  },
  "refreshToken": {
    "property": "refresh_token"
  },
  "token": {
    "type": "Bearer",
    "property": "access_token"
  },
  "user": {
    "autoFetch": true,
    "property": false
  },
  "appVersion": "6.0.0",
  "name": "apiWithFb"
}))

  // facebook
  $auth.registerStrategy('facebook', new Oauth2Scheme($auth, {
  "endpoints": {
    "authorization": "https://facebook.com/v19.0/dialog/oauth",
    "userInfo": "https://graph.facebook.com/v19.0/me?fields=id,name,picture{url}"
  },
  "clientId": "322609621584500",
  "redirectUri": "https://club.teampulse.net/auth/callback/facebook",
  "name": "facebook",
  "scope": [
    "public_profile",
    "email"
  ]
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
